<div class="container" *ngIf="fullResponse">

<ng-container>
  <!--  No. of items display and pagination section -  START-->
  <div class="row mb-2">
    <div class="col-2 totalResultDisplay">
      {{ fullResponse.pagination.totalResults }} {{ "myFavourites.items" | cxTranslate }}
    </div>
    <div class="col-8"></div>
    <div class="col-2 float-right">
      <div class="cx-pagination" aria-label="product search pagination">

        <cx-pagination
        [pagination]="fullResponse.pagination"
        queryParam="currentPage"
        [defaultPage]="currentPage"
        (viewPageEvent)="currentPage($event)"
      ></cx-pagination>
      </div>
    </div>
  </div>
  <!--  No. of items display and pagination section -  END-->

  <!-- Master Checkbox and the BULK products BUY QUOTE REMOVE button section - START -->
  <div class="row">
    <div class="col-lg-6 col-sm-6 col-sm-12">
      <div class="custom-control custom-checkbox">
        <input
          type="checkbox"
          id="master"
          class="custom-control-input"
          [disabled]="fullResponse.wishlist2EntryList.length == 0"
          [indeterminate]="client.indeterminated"
          [checked]="client.checked"
          (click)="onMasterClick(client, $event);"
        />
        <label class="custom-control-label" for="master"></label>
      </div>
      <div class="bulk-select-section">
        <a class="bulk-btn mr-5"
        [class.disabled-btn]="fullResponse.wishlist2EntryList.length == 0"
        [ngClass]="(checkUserEnabled(accessibility.SELLABILITYFLAG) | async) ?'':'hide-btn'"
        (click)="bulkBuy()">
          <em class="material-icons">shopping_cart</em
          ><span class="bulk-btn-txt"> {{ "myFavourites.buy" | cxTranslate }}</span>
        </a>
        <a class="bulk-btn mr-5"
        [class.disabled-btn]="fullResponse.wishlist2EntryList.length == 0"
        [ngClass]="(checkUserEnabled(accessibility.QUOTABILITYFLAG) | async)  ?'':'hide-btn'"
        (click)="bulkQuote()">
          <em class="material-icons">receipt</em
          ><span class="bulk-btn-txt"> {{ "myFavourites.getAQuote" | cxTranslate }}</span>
        </a>
        <a class="bulk-btn mr-5"
        [class.disabled-btn]="fullResponse.wishlist2EntryList.length == 0"
        (click)="bulkRemove()">
          <em class="material-icons">delete</em
          ><span class="bulk-btn-txt"> {{ "myFavourites.removeBtn" | cxTranslate }}</span>
        </a>
        </div>
      </div>
      <!-- Master Checkbox and the BULK products BUY QUOTE REMOVE button section - END -->

      <!-- Search Filter -->
      <div class="col-sm-6 float-right">
        <div class="search">
          <input type="text"
            class="form-control search-btn"
            placeholder='{{ "myFavourites.searchPlaceholder" | cxTranslate }}'
            name="search"
            [(ngModel)]="searchText"
            #search
            (keyup)="keyUp(search.value, $event)"
          >
          <span>
            <i class="material-icons search-icon"
            (click)="modelChange(search.value)">search</i>
          </span>
        </div>
      </div>
    </div>

    <div class="clear-filter">
      <div class="left-content filter-txt" *ngIf="searchFilter">
        {{ "myFavourites.search" | cxTranslate }}{{this.searchText}}
        <i class="material-icons" (click)="clearSearchFilter()">close</i>
      </div>
    </div>

</ng-container>

<ng-container *ngIf="fullResponse?.wishlist2EntryList?.length > 0 else emptyFavList">
  <!-- TABLE SECTION : Dusplay of Favourite Products - START -->
  <div class="row">
    <table class="table table-responsive-md" *ngIf="!displayLoader" else loading>
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">{{ "myFavourites.productHeader" | cxTranslate }}</th>
          <th scope="col"></th>
          <th scope="col">{{ "myFavourites.descriptionHeader" | cxTranslate }}</th>
          <th scope="col">{{ "myFavourites.quantityHeader" | cxTranslate }}</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let productObj of fullResponse.wishlist2EntryList; let i = index">
          <!--  TABLE COLUMN 1 : CHECKBOX -->
          <td class="w-5">
            <div class="custom-control custom-checkbox moveUp">
              <input
                type="checkbox"
                class="custom-control-input"
                [id]="i"
                [checked]="productObj.product.selected"
                (change)="onProductSelect(productObj, i, $event)"
              />
              <label class="custom-control-label" [for]="i"></label>
            </div>
          </td>
          <!--  TABLE COLUMN 2 : IMAGE -->
          <td class="w-2">
            <a
              [routerLink]="{ cxRoute: 'product', params: productObj.product } | cxUrl"
              (click)="gtmSelectItemEvent(productObj.product)"
              class="cx-product-image-container"
              tabindex="-1"
            >
              <cx-media
                class="cx-product-image"
                [container]="getProductImageUrl(productObj)"
                [alt]="productObj.product.name"
              ></cx-media>
            </a>
          </td>
          <!--  TABLE COLUMN 3 : PRODUCT DETAILING -->
          <td class="w-35">
            <a
            class="pdp-link-code"
            [routerLink]="{ cxRoute: 'product', params: productObj.product } | cxUrl"
            (click)="gtmSelectItemEvent(productObj.product)"
            ><span [innerHTML]="productObj.product.code"></span
          ></a>
            <a
              class="pdp-link"
              [routerLink]="{ cxRoute: 'product', params: productObj.product } | cxUrl"
              (click)="gtmSelectItemEvent(productObj.product)"
              ><span [innerHTML]="productObj.product.name"></span
            ></a>
            <div
              class="obsolete-prdct-warning"
              *ngIf="productObj.product.obsoleteProductFlag"
            >
              <em class="material-icons">warning</em> {{ "myFavourites.obsoletePart" | cxTranslate }}
            </div>
            <div
            class="obsolete-prdct-warning"
            *ngIf="productObj.product.displayAlternativetext"
          >
            <em class="material-icons">warning</em> {{ "myFavourites.availableInOtherLegalEntity" | cxTranslate }}
          </div>
          </td>
          <!--  TABLE COLUMN 4 : DESCRIPTION -->
          <td class="w-35">
            <div class="descriptionText">
                {{productObj.comment}}
            </div>
          </td>
          <!--  TABLE COLUMN 5 : QUANTITY -->
          <td class="w-45">
            <div class="qtySection">
              <div
                class="qtyTxt"
                placement="left"
                title="{{ 'cartItems.quantityTitle' | cxTranslate }}"
              >
                {{ "cartItems.quantity" | cxTranslate }}
              </div>
              <div class="float-left">
                <vs-item-counter
                  [control]="form.get(productObj.product.code)"
                  (quantityIncrement)="onProductQtyIncrement(productObj)"
                  (quantityDecrement)="onProductQtyDecrement(productObj)"
                  [max]="9999"
                  [allowZero]="true"
                  [readonly]="readonly"
                ></vs-item-counter>
              </div>
              <div placement="right" class="qtyEachTxt">
                {{ productObj.product.salesUnit }}
              </div>
            </div>
          </td>
          <!--  TABLE COLUMN 6 : BUTTONS -->
          <td class="w-10">
            <div class="pos-individual-btn-pack">
              <a
                class="individual-btn ml-4"
                [ngClass]="((checkUserEnabled(accessibility.SELLABILITYFLAG) | async) && checkProductEligibleToBuy(productObj))?'':'hide-btn'"
                (click)="addProductToBuyCart(productObj)"
              >
                <em class="material-icons">shopping_cart</em>
              </a>
              <a
                class="individual-btn ml-4"
                [ngClass]="(checkUserEnabled(accessibility.QUOTABILITYFLAG) | async)  ?'':'hide-btn'"
                (click)="addProductToQuoteCart(productObj)"
              >
                <em class="material-icons">receipt</em>
              </a>
              <a
                class="individual-btn ml-4"
                (click)="removeProductFromFavList(productObj)"
              >
                <em class="material-icons">delete</em>
              </a>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <!-- TABLE SECTION : Dusplay of Favourite Products - END -->

  <!--   pagination section -  START-->
  <div class="row mt-2 mb-2 float-right">
    <div class="pagination-section-below">
      <div class="cx-pagination" aria-label="product search pagination">
        <cx-pagination
        [pagination]="fullResponse.pagination"
        queryParam="currentPage"
        [defaultPage]="currentPage"
        (viewPageEvent)="currentPage($event)"
      ></cx-pagination>
      </div>
    </div>
  </div>
  <!--   pagination section -  END-->
</ng-container>

<ng-template #emptyFavList>
  <div *ngIf="!displayLoader">
    <div *ngIf="!noData">
      <vs-empty-list></vs-empty-list>
    </div>
    <div *ngIf="noData" class="noData">
      <div class="img"></div>
       <h2 class="heading">{{ "myFavourites.noFavourites" | cxTranslate }}</h2>
    </div>
  </div>
</ng-template>
</div>

<!-- PAGINATION symbol to load on screen - START -->
<div class="spinner-class" *ngIf="displayLoader" #loading>
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
</div>
<!-- PAGINATION symbol to load on screen - END -->
